/**
  * Module Class
  * @param {number} id - Unique id
  * @param {string} title - The Module Title
  * @param {string} query - The Url query
  * @param {Datetime} archived - The Archive dateTime
  * @param {Datetime} created - The creation date
	* @param {string} url - the url
  * @returns {Object} - Module's Model
**/
class Module {
	constructor({
		id,
		title,
		query,
		archived,
		created,
		url,
		action_data: actionData,
		short_url: shortURL,
	} = {}) {
		this._id = id || null;
		this._title = title || null;
		this._query = query  || null;
		this._archived = archived || null;
		this._created = created || null;
		this._url = url || null;
		this._actionData = actionData || {};
		this._shortURL = shortURL;
	}

	getId() {
		return this._id;
	}

	getKey() {
		return String(this._id);
	}

	toString() {
		return this._title;
	}

	getHref() {
		// Old modules, or in case of an error, a module won`t have a generated url
		return this._shortURL || this._url;
	}

	getShortURL() {
		return this._shortURL;
	}

	getName() {
		return this._title;
	}

	getQuery() {
		return this._query;
	}

	getArchived() {
		return this._archived;
	}

	getCreated() {
		return this._created;
	}

	getURL() {
		return this._url;
	}

	getReferrerList(){
		return this._actionData.referrer;
	}

	getPageList(){
		return this._actionData.page;
	}
}

export default Module;

export class ModuleDetails {
	constructor({
		action_data: actionData,
	} = {}) {
		this._actionData = actionData || {};
	}

	getKey(){
		return '';
	}

	getReferrerList(){
		return this._actionData.referrer;
	}

	getPageList(){
		return this._actionData.page;
	}
}
